import { Dialog, dialogClasses, paperClasses } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import {
  Agreement as AgreementType,
  agreements,
} from '../../../../shared/utils/agreement';

import { BlueRoundedButton, ButtonContainer } from './BlueRoundedButton';
import { CloseButtonContainer, ModalCloseButton } from './ModalCloseButton';

const ModalHeading = styled.span`
  font-weight: 700;
  font-size: 18px;
  text-align: center;
`;

const ModalContainer = styled.div`
  display: contents;
  position: relative;
  margin: 0;
  padding: 20px;
`;

const TermContainer = styled.div`
  margin-top: 10px;
  padding: 10px;
  background-color: #f3f4f6;
`;

interface AgreementModalProps {
  open: boolean;
  onClose: () => void;
  onAllow: () => void;
  agreementType: AgreementType;
}
export const AgreementModal = (props: AgreementModalProps) => {
  const { open, onClose, onAllow, agreementType } = props;
  const { t } = useTranslation('translation', { keyPrefix: 'common' });

  const agreementTitle =
    agreementType === AgreementType.personalInformationV2
      ? t(`agreement.${AgreementType.personalInformation}`)
      : agreementType === AgreementType.termsOfServiceV2
      ? t(`agreement.${AgreementType.termsOfService}`)
      : t(`agreement.${agreementType}`);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        [`.${dialogClasses.container}`]: {
          maxHeight: '100%',
          height: 'auto',
        },
        [`.${paperClasses.root}`]: {
          maxHeight: '800px',
          height: 'inherit',
          padding: '30px 10px',
          boxSizing: 'border-box',
        },
      }}>
      <ModalContainer>
        <CloseButtonContainer>
          <ModalCloseButton onClick={onClose} />
        </CloseButtonContainer>
        <ModalHeading>{agreementTitle}</ModalHeading>
        <TermContainer
          dangerouslySetInnerHTML={{ __html: agreements[agreementType] }}
        />
      </ModalContainer>
      <ButtonContainer>
        <BlueRoundedButton marginTop="29px" onClick={onAllow}>
          {t('button.agree')}
        </BlueRoundedButton>
      </ButtonContainer>
    </Dialog>
  );
};
